export default function EditRecommendationCommentDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  amDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveRecommendationComment = _handleSaveRecommendationComment;

  vm.IsValidControl = _IsValidControl;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editRecommendationCommentDialog);
  }

  function _handleSaveRecommendationComment() {
    const dfdSave = $q.defer();

    if ($scope.editAMRecommendationNoteForm.$valid) {
      amDataService
        .saveRecommendationComment(vm.recommendationId, vm.recommendationCommentId, vm.recommendationCommentText)
        .then(response => {
          if (!response.data) {
            alerts.error('Error occurred while saving the Recommendation Note.');
          } else {
            alerts.success('The Recommendation Note has been saved successfully.');
            $rootScope.$broadcast('refreshAMRecommendationComments', { recommendationId: vm.recommendationId });
            ssDialogService.hide(ssDialogService.dialogs.auditTrail.editRecommendationCommentDialog);
          }
          dfdSave.resolve();
        });
    } else {
      dfdSave.reject();
    }
  }

  function _IsValidControl(ctrl) {
    return ($scope.editAMRecommendationNoteForm)
      && (($scope.editAMRecommendationNoteForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

EditRecommendationCommentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'amDataService'
];
